// Hover labels: any element with data-n-tip="…" shows one tooltip above it.
let tip: HTMLDivElement | null = null;

export function initTooltips(): void {
	document.addEventListener('mouseover', (e) => {
		const el = (e.target as Element).closest<HTMLElement>('[data-n-tip]');
		if (!el) return;
		tip ??= Object.assign(document.createElement('div'), { className: 'n-tooltip', role: 'tooltip' });
		if (!tip.isConnected) document.body.appendChild(tip);
		tip.textContent = el.dataset.nTip ?? '';
		const r = el.getBoundingClientRect();
		tip.style.left = `${Math.max(8, Math.min(window.innerWidth - tip.offsetWidth - 8, r.left + r.width / 2 - tip.offsetWidth / 2))}px`;
		tip.style.top = `${Math.max(8, r.top - tip.offsetHeight - 8)}px`;
		tip.dataset.open = '';
		el.addEventListener('mouseleave', () => tip && delete tip.dataset.open, { once: true });
	});
}
